import { render, staticRenderFns } from "./AiSummaryButton.vue?vue&type=template&id=187976ff&scoped=true"
import script from "./AiSummaryButton.vue?vue&type=script&lang=js"
export * from "./AiSummaryButton.vue?vue&type=script&lang=js"
import style0 from "./AiSummaryButton.vue?vue&type=style&index=0&id=187976ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187976ff",
  null
  
)

export default component.exports